module.exports = __webpack_public_path__ + "img/ui_b_0.308df1fc.png";